import Header from './Header.vue';

export default Header;



// WEBPACK FOOTER //
// ./src/pages/profile/views/progress/components/header/index.ts